import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailKvListValue,
    KV_LIST_TYPES,
    DetailPanel,
    DetailKvTable,
    DetailFilePanel,
    DetailSummaryPrintButton,
} from '../../../../components/detailLayout';
import Th_title from "../../../../components/Th_title";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {inspectionRequestCode} from "../InspectionCreate";
import {SimmsRadio} from "../../../../components/input/SimmsRadio";
import {inspectionReportCodeType} from "../../../settings/report/InspectionReportCode/inspectionReportCodeConstants";
import React, {useEffect, useState} from "react";
import {saveInspectionReport} from "../../../../api/maintenance/InspectionService";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import Selector from "../../../../components/selector/Selector";
import SignContainer from "../../../../components/basic/SignContainer";
import {useDispatch} from "react-redux";
import InspectionReportItem from "./InspectionReportItem";
import InspectionReportAssetItem from "./InspectionReportAssetItem";
import {buildReportViewGroups, groupByGroupName} from "../../../../components/commonmethod/CommonMethod";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import {ContentCategory} from "../../../../constant/CodeSpecNum";

function InspectionReportCreate({inspection, assets, handler, inspectionReport, setInspectionReport, statusNumericValue}){

    const [docs, setDocs] = useState([]);
    const [type, setType] = useState(inspectionReportCodeType[0].value);
    const dispatch = useDispatch();
    const [view, setView] = useState();

    useEffect(() => {
        const settings = localStorage.getItem("setting");
        setView(JSON.parse(settings)?.find(e => e.globalsNmAsSnake === "inspectionReport")?.globalsValue === "true")
    }, [dispatch])

    const create = async ()=>{
        const docFile=[]
        docs.forEach(each=>docFile.push(each.object))

        if(!inspectionReport.inspectionReportCode?.id){
            alert("점검내용 코드구분을 선택해주세요")
            return
        }

        const updatedReportViewChildren = inspectionReport.reportView?.flatMap(group =>
            group.child.map(item => ({
                ...item
            }))
        );

        const updatedAssetViewChildren = inspectionReport.assetView?.flatMap(group =>
            group.child.map(item => ({
                ...item
            }))
        );

        const data = {
            ...inspectionReport,
            inspection: {id : inspection.id},
            assetView: view && updatedAssetViewChildren?.length > 0 ? updatedAssetViewChildren : [],
            reportView: !view && updatedReportViewChildren?.length > 0 ? updatedReportViewChildren : [],
            inspectionReportCode : {id : inspectionReport.inspectionReportCode.id}
        };

        const response = await saveInspectionReport(data, docFile);
        if(response.status === 200){
            setInspectionReport(response.data);
            alert("등록되었습니다.")
        }
    }

    const onChangeConnectedInfo = (each) => {
        if(inspectionReport.inspectionReportCode?.id === each.id){
            setInspectionReport(prev => {
                const newState = { ...prev };
                delete newState.inspectionReportCode;
                delete newState.assetView;
                delete newState.reportView;

                return newState;
            });

            return;
        }else{
            setInspectionReport((prev) => ({
                ...prev,
                inspectionReportCode : each
            }))
        }

        if (view === true) {
            initAsset(each.children);
        }else{
            initReport(each.children);
        }
    };

    function initAsset(list) {
        const groupList = groupByGroupName(list);

        const remain = groupList.map(group => ({
            ...group,
            child: group.child.flatMap(item => {
                if (parseInt(item.type) === 1) {
                    return assets.map(e => ({
                        assetId: e.id,
                        codeId: item.id,
                        value: 0
                    }));
                }
                return [];
            })
        }));

        setInspectionReport((prev) => ({...prev, assetView : remain}))
    }

    function initReport(list) {
        setInspectionReport((prev) => ({...prev, reportView: buildReportViewGroups(list)}));
    }

    const summaryMeta = [
        inspection.inspectCode?.name && `코드 ${inspection.inspectCode.name}`,
        inspection.requester?.name && `요청 ${inspection.requester.name}`,
    ].filter(Boolean).join(" · ");

    const requestInfoPanel = (
        <DetailPanel title={"점검요청정보"}>
            <DetailKvTable>
                <tbody>
                    <tr>
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                            <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdAt"} value={inspection.createdAt} />
                        </Th_title>
                        <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdBy"} value={inspection.createdBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedAt"} value={inspection.updatedAt} />
                        </Th_title>
                        <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedBy"} value={inspection.updatedBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검 제목"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"title"} value={inspection.title} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"requester"} value={inspection.requester} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                            <DetailKvListValue items={handler} listType={KV_LIST_TYPES.user} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검코드"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"inspectCode"} value={inspection.inspectCode?.name} />
                        </Th_title>
                        <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"requestCode"} value={ inspectionRequestCode.find(data => data.id === inspection.requestCode) } />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검기간"} colspan={3} className="fieldset-td fieldset-td-input">
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker data={inspection.inspectStartDate} readonly />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker data={inspection.inspectEndDate} readonly />
                            </div>
                        </Th_title>
                    </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const reportContentPanels = (
        <>
            <DetailPanel title={"점검내용"}>
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <Th_title title={"점검결과"} colspan={3} className="fieldset-td" auth={inspection.auth.update}>
                                <SimmsTextArea
                                    onChange={(v)=>inputOnChange(setInspectionReport,"inspectionResult", v, false)}
                                    data={inspectionReport.inspectionResult}
                                    style={{width: "100%"}}
                                />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"코드 구분"} colspan={3} className="fieldset-td">
                                <SimmsRadio
                                    title="코드 구분"
                                    options={inspectionReportCodeType}
                                    data={type}
                                    onChange={(v) => {
                                        setType(v);
                                        delete inspectionReport.reportView;
                                        delete inspectionReport.assetView;
                                        delete inspectionReport.inspectionReportCode;
                                    }}
                                />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"보고서 코드"} colspan={3} className="fieldset-td" auth={inspection.auth.update}>
                                <Selector
                                    onChange={(v)=>onChangeConnectedInfo(v)}
                                    data={inspectionReport.inspectionReportCode}
                                    entity={type == "company" ? "inspectionReportCompany" : "inspectionReportAsset"}
                                    uniqueKey={type}>

                                    <SimmsInputSearch type={'TEXT'} placeHolder={"코드명"} />
                                </Selector>
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>

            <InspectionReportItem view={view} obj={inspectionReport} status={"create"} setter={setInspectionReport} />
            <InspectionReportAssetItem view={view} obj={inspectionReport} status={"create"} asset={assets} setter={setInspectionReport} />
        </>
    );

    const filePanel = (
        <>
            <SignContainer contentId={inspection.id} contentCategory={"INSPECTION"} statusNumericValue={statusNumericValue} />
            <DetailFilePanel
                pendingFiles={{files: docs, setFiles: setDocs}}
                pendingInputId="inspection_report_create_doc"
                showFileLabel={false}
            />
        </>
    );

    return (
        <ContentDetailInfoShell
            title={inspection?.title || "점검보고서 등록"}
            meta={summaryMeta || undefined}
            contentId={inspection.id}
            contentCategory={ContentCategory.INSPECTION}
            scrollMode="columns"
            trackActions
            actions={<DetailSummaryPrintButton />}
            rollup={{
                create: inspection.auth?.update && create,
            }}
        >
            <ContentDetailThreeColLayout
                primary={requestInfoPanel}
                secondary={reportContentPanels}
                aside={filePanel}
            />
        </ContentDetailInfoShell>
    )
}

export {InspectionReportCreate}
